// extracted by mini-css-extract-plugin
export default {"primary":"PrimaryInput_primary__1rxS9"};